export const Questions = [
  {
    prompt: "Inside which HTML element do we put the JavaScript?",
    optionA: "<javascript>",
    optionB: "<scripting>",
    optionC: "<script>",
    optionD: "<js>",
    answer: "<script>",
  },
  {
    prompt: "How do you create a function in JavaScript?",
    optionA: "function = myFunction()",
    optionB: "function myFunction()",
    optionC: "function:myFunction()",
    optionD: "myFunction()",
    answer: "function myFunction()",
  },
  {
    prompt: "How to write an IF statement in JavaScript?",
    optionA: "if i = 5 then",
    optionB: "if i == 5 then",
    optionC: "if i = 5",
    optionD: "if (i == 5)",
    answer: "if (i == 5)",
  },
  {
    prompt: "How does a WHILE loop start?",
    optionA: "while i = 1 to 10",
    optionB: "while (i <= 10)",
    optionC: "while (i <= 10; i++)",
    optionD: "while i <= 10",
    answer: "while (i <= 10)",
  },
  {
    prompt: "How does a FOR loop start?",
    optionA: "for i = 1 to 5",
    optionB: "for (i = 0; i <= 5)",
    optionC: "for (i <= 5; i++)",
    optionD: "for (i = 0; i <= 5; i++)",
    answer: "for (i = 0; i <= 5; i++)",
  },
  {
    prompt: "How do you round the number 7.25, to the nearest integer?",
    optionA: "rnd(7.25)",
    optionB: "Math.round(7.25)",
    optionC: "round(7.25)",
    optionD: "Math.rnd(7.25)",
    answer: "Math.round(7.25)",
  },
  {
    prompt: "How do you find the number with the highest value of x and y?",
    optionA: "Math.max(x, y)",
    optionB: "ceil(x, y)",
    optionC: "top(x, y)",
    optionD: "Math.ceil(x, y)",
    answer: "Math.max(x, y)",
  },
  {
    prompt: "How can you detect the client's browser name?",
    optionA: "navigator.appName",
    optionB: "client.navName",
    optionC: "browser.name",
    optionD: "server.name",
    answer: "navigator.appName",
  },
  {
    prompt: "Which operator is used to assign a value to a variable?",
    optionA: "*",
    optionB: "-",
    optionC: "x",
    optionD: "=",
    answer: "=",
  },
  {
    prompt: "What will the following code return: Boolean(10 > 9)",
    optionA: "NaN",
    optionB: "true",
    optionC: "false",
    optionD: "correct",
    answer: "true",
  },
];
